import { AddUpdateTaskParams } from '@nextforce/api'
import { useTheme } from '@rneui/themed'
import { t } from 'app/i18l'
import { EditRecurrentTaskScreenProps } from 'home/stack/types'
import { useCallback, useLayoutEffect, useState } from 'react'
import { showHeaderButton } from 'shared/header/header_button'
import { showHeaderTitle } from 'shared/header/header_title'
import { useAddEditTaskContext } from 'tasks/context'
import { validateRecurringTask } from 'tasks/utils'
import { EditRecurrentTaskView } from './views'

export function EditRecurrentTaskScreen({
  navigation,
  route,
}: EditRecurrentTaskScreenProps) {
  const { theme } = useTheme()
  const { taskFields, setTaskFields } = useAddEditTaskContext()

  const type = route.params?.taskId ? 'edit' : 'add'

  const [taskParams, setTaskParams] = useState<AddUpdateTaskParams>(taskFields)

  const onPressDone = useCallback(() => {
    setTaskFields(prev => ({ ...prev, ...taskParams, recurring: true }))
    navigation.goBack()
  }, [navigation, taskParams, setTaskFields])

  useLayoutEffect(() => {
    showHeaderButton({
      navigation,
      theme,
      title: t('done'),
      onPress: onPressDone,
      disabled: !validateRecurringTask(taskParams),
    })
  }, [navigation, onPressDone, taskParams, theme])

  useLayoutEffect(() => {
    showHeaderTitle(
      navigation,
      type === 'edit' ? t('editRecurrentTask') : t('addRecurrentTask')
    )
  }, [navigation, type])

  return (
    <EditRecurrentTaskView
      taskParams={taskParams}
      setTaskParams={setTaskParams}
    />
  )
}
